import { gql } from '@apollo/client';
import { useQuery, useSuspenseQuery } from '@apollo/client/react';

const ORGANIZATION_MAX_SERVICES_PER_APPOINTMENT_QUERY = gql`
    query OrganizationMaxServicesPerAppointmentQuery {
        currentOrganization {
            id
            config {
                id
                maxServicesPerAppointment
            }
        }
    }
`;

interface IOrganizationMaxServicesPerAppointmentQuery {
    currentOrganization: {
        id: string;
        config: {
            id: string;
            maxServicesPerAppointment: number | null;
        };
    };
}

// Suspends until the org config loads. Use only under a Suspense boundary.
export const useMaxServicesPerAppointmentSuspense = (): number | null => {
    const { data } = useSuspenseQuery<IOrganizationMaxServicesPerAppointmentQuery>(
        ORGANIZATION_MAX_SERVICES_PER_APPOINTMENT_QUERY,
    );

    return data.currentOrganization.config.maxServicesPerAppointment;
};

// Non-suspending: exposes loading so callers render their own loading state.
export const useMaxServicesPerAppointment = (): {
    data: number | null | undefined;
    loading: boolean;
} => {
    const { data, loading } = useQuery<IOrganizationMaxServicesPerAppointmentQuery>(
        ORGANIZATION_MAX_SERVICES_PER_APPOINTMENT_QUERY,
    );

    return { data: data?.currentOrganization.config.maxServicesPerAppointment, loading };
};
